import { useEffect, useState } from "react";

const useDeviceType = () => {
  // 초기 렌더부터 실제 화면 폭으로 판별해, PC/모바일 이미지가 둘 다
  // 다운로드되는 것을 방지한다.
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth <= 768 : false
  );

  useEffect(() => {
    const checkDevice = () => {
      setIsMobile(window.innerWidth <= 768); // 모바일 기준 너비
    };

    checkDevice(); // 첫 실행

    window.addEventListener("resize", checkDevice); // 창 크기 변경 대응

    return () => window.removeEventListener("resize", checkDevice);
  }, []);

  return isMobile;
};

export default useDeviceType;
